module.exports = __webpack_public_path__ + "img/contentinfo1.dfc09e5d.png";